import { useState } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { updateQueryParams } from "lib/queryParams";
import { createStandardToast, createToastResponseError } from "lib/toastify";
import { templatesService } from "services/templates";
import { clearCheckPageState } from "services/store/pagesSlice";
import { useAppDispatch, useAppSelector } from "services/hooks";
import { selectModalData } from "services/store/modalDataSlice";

import { Button } from "../../components/Buttons/Button";
import { ModalButtonsContainer } from "../../components/Modals/ModalButtonsContainer";
import { ModalTextContainer } from "../../components/Modals/ModalTextContainer";
import { ModalDefaultFormContainer } from "../../components/Modals/ModalDefaultFormContainer";
import { Link } from "../../components/Link";

export const DeleteTemplates: CT<{ onClose: VoidFunction }> = ({ onClose }) => {
  const modalData = useAppSelector(selectModalData);
  const [isLoad, setLoad] = useState(false);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const onDeleteData = async () => {
    if (!modalData?.ids?.length ?? null) {
      toast("id не найдены", {
        type: "warning",
        autoClose: 3000,
      });
      onClose();
    }
    try {
      setLoad(true);
      const response = await templatesService.delete(modalData!.ids);
      toast(response.data.message, { autoClose: 3000 });
      dispatch(clearCheckPageState({ page: "templatesChecked" }));
      dispatch(clearCheckPageState({ page: "templatesDefaultChecked" }));
      updateQueryParams(history, {
        page: "1",
      });
    } catch (e) {
      if (e.response?.data?.code === 1003) {
        createStandardToast(
          <p>
            Прежде чем редактировать/удалить шаблон - необходимо{" "}
            <Link
              color={"onlyPrimary"}
              link={"/mailing/?page=1&per-page=25&sortBy=name&tab=draft"}
            >
              завершить/удалить рассылки
            </Link>
          </p>
        )();
        return;
      }
      createToastResponseError(e)();
    } finally {
      onClose();
    }
  };

  return (
    <ModalDefaultFormContainer>
      <ModalTextContainer>
        <p>Вы уверены, что хотите удалить выбранные шаблоны?</p>
      </ModalTextContainer>
      <ModalButtonsContainer>
        <Button isLoad={isLoad} onClick={onDeleteData} type={"submit"}>
          Подтвердить
        </Button>
        <Button onClick={onClose} type={"submit"} variant={"secondary"}>
          Отмена
        </Button>
      </ModalButtonsContainer>
    </ModalDefaultFormContainer>
  );
};
